import { NextPageContext } from 'next';
import Router from 'next/router';

const redirectTo = (redirectUrl: string, ctx: NextPageContext): void => {
  if (ctx.req && ctx.res) {
    ctx.res.writeHead(302, {
      Location: redirectUrl,
    });
    ctx.res.end();
  } else {
    Router.replace(redirectUrl);
  }
};

export default redirectTo;
